import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const publicApi = axios.create({
  baseURL: `${API_BASE_URL}/public`,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface CompanyInfo {
  name: string;
  description: string;
  founded: number;
  location: string;
  mission: string;
  vision: string;
  values: string[];
  services: string[];
  contact: {
    phone: string;
    email: string;
    address: string;
    website: string;
  };
}

export interface Service {
  id: number;
  title: string;
  description: string;
  category: string;
  features: string[];
  icon: string;
  image: string;
}

export interface Testimonial {
  id: number;
  name: string;
  company: string;
  role: string;
  content: string;
  rating: number;
  image: string;
}

export interface CompanyStats {
  yearsExperience: number;
  projectsCompleted: number;
  happyCustomers: number;
  teamMembers: number;
  productionCapacity: string;
  qualityRating: string;
  deliveryTime: string;
  countriesServed: number;
}

export interface ContactFormData {
  name: string;
  email: string;
  phone?: string;
  company?: string;
  message: string;
  service?: string;
}

export interface QuoteRequestData {
  name: string;
  email: string;
  phone: string;
  company: string;
  service: string;
  description: string;
  quantity?: number;
  timeline?: string;
  budget?: string;
}

export interface TourBookingData {
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  companyName?: string;
  jobTitle?: string;
  tourDate: string;
  tourTime: string;
  groupSize: number;
  tourType: string;
  specialInterests?: string;
  accessibilityNeeds?: string;
  additionalNotes?: string;
  preferredGuide?: string;
  language: string;
}

export interface NewsletterSubscription {
  email: string;
}

export interface TourBookingData {
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  companyName?: string;
  jobTitle?: string;
  tourDate: string;
  tourTime: string;
  groupSize: number;
  tourType: string;
  specialInterests?: string;
  accessibilityNeeds?: string;
  additionalNotes?: string;
  preferredGuide?: string;
  language: string;
}

// Company Information
export const getCompanyInfo = async (): Promise<CompanyInfo> => {
  const response = await publicApi.get('/company/info');
  return response.data;
};

// Services
export const getServices = async (): Promise<Service[]> => {
  const response = await publicApi.get('/services');
  return response.data;
};

// Products
export const getPublicProducts = async (query?: any) => {
  const response = await publicApi.get('/products', { params: query });
  return response.data;
};

export const getFeaturedProducts = async () => {
  const response = await publicApi.get('/products/featured');
  return response.data;
};

export const getProductCategories = async () => {
  const response = await publicApi.get('/products/categories');
  return response.data;
};

// Testimonials
export const getTestimonials = async (): Promise<Testimonial[]> => {
  const response = await publicApi.get('/testimonials');
  return response.data;
};

// Company Statistics
export const getCompanyStats = async (): Promise<CompanyStats> => {
  const response = await publicApi.get('/stats');
  return response.data;
};

// Contact Form
export const submitContactForm = async (data: ContactFormData) => {
  const response = await publicApi.post('/contact', data);
  return response.data;
};

// Quote Request
export const submitQuoteRequest = async (data: QuoteRequestData) => {
  const response = await publicApi.post('/quote-request', data);
  return response.data;
};

// Tour Booking
export const bookTour = async (data: TourBookingData) => {
  const response = await publicApi.post('/book-tour', data);
  return response.data;
};

// Project Details
export const getProjectById = async (id: string) => {
  const response = await publicApi.get(`/portfolio/${id}`);
  return response.data;
};

export default publicApi; 